
import { Item } from '@/interfaces/building.interface';
import router from '@/router'
import { apiUrl, axiosAuthGet, axiosAuthPost } from '@/services/utils'
import { defineComponent } from 'vue'
import { Apartment } from '@/interfaces/apartment.interface';
import AddApartmentModal from '@/components/AddApartmentModal.vue';
import Overlay from '@/components/Overlay.vue';
import ApartmentDetailsModal from '@/components/ApartmentDetailsModal.vue';
import BasicSpinner from '@/components/BasicSpinner.vue';
import { topBarState } from '@/services/topBar';
import { getAllApartments } from '@/services/ApartmentService';
import { getReadableDate } from '@/services/DateService';

export default defineComponent({
    setup() {
    },
    mounted() {
        topBarState.updateTitle('apartments')
        this.getApartments();
    },
    data() {
        return {
            // filter variable
            filter:'all',
            addAppartForm: false,
            apartmentDetails: false,
            apartments: [] as Apartment[],
            currentApart: {} as Apartment,
            buildingItems: [] as Item[],
            apartmentItems: [] as Item[],
            showDropdown: false,
            showApart: false,
            spin: false,
            itemForm: false,
            hasClicked: false,
            deleteSpin: false,
            formData: {
                name: "",
                description: "",
                type: "classic",
                price: ""
            },
            itemFormData: {
                selectedItem: {} as Item,
                quantity: 0
            }
        };
    },
    computed: {
        filterApartments(): any[] {
            let filteredAparts = this.apartments;
            if(this.filter == 'available') {
                filteredAparts = filteredAparts.filter(apart => apart.isFree == true);
            } else if(this.filter == 'occupied') {
                filteredAparts = filteredAparts.filter(apart => apart.isFree == false);
            } else {
                filteredAparts = this.apartments;
            }
            return filteredAparts;
        }
    },
    methods: {
        // dropdown button action
        dropdown(apartment: Apartment) {
            this.showDropdown = !this.showDropdown;
            this.currentApart = apartment;
        },
        // show apartment details modal
        displayApartDetails(apartment: Apartment) {
            this.currentApart = apartment;
            this.apartmentDetails = true;
        },
        async getApartments() {
            this.addAppartForm = false;
            this.apartmentDetails = false;
            this.spin = true;
            this.apartments = await getAllApartments();
            this.spin = false;
        },
        // delete an apartment
        deleteApartment(apartment: Apartment) {
            let apartUrl = apiUrl + "apartment/delete/" + apartment._id;
            if (confirm("do you really want to delete this apartment?")) {
                this.deleteSpin = true;
                axiosAuthPost(apartUrl, {}).then((result) => {
                    let index = this.apartments.indexOf(apartment);
                    this.apartments.splice(index, 1);
                    this.deleteSpin = false;
                }).catch((err) => {
                    this.deleteSpin = false;
                });
            }
        },
        getBuildingItems() {
            let buildingId = router.currentRoute.value.params.building;
            let apartUrl = apiUrl + "building/items/list/" + buildingId;
            axiosAuthGet(apartUrl).then((result) => {
                this.buildingItems = result;
            }).catch((err) => {
            });
        },

        addItem() {
            let apartUrl = apiUrl + "apartment/items/add/" + this.currentApart._id;
            let itemData = {
                name: this.itemFormData.selectedItem.name,
                price: this.itemFormData.selectedItem.price,
                quantity: this.itemFormData.quantity
            };
            axiosAuthPost(apartUrl, itemData).then((result) => {
                this.currentApart = result.apartment;
            }).catch((err) => {
            });
        },
        removeItem(item: Item) {
            let apartUrl = apiUrl + "apartment/items/delete/" + this.currentApart._id;
            axiosAuthPost(apartUrl, item).then((result) => {
                let index = this.currentApart.items.indexOf(item);
                this.currentApart.items.splice(index, 1);
            }).catch((err) => {
            });
        },
        getReadDate(date: Date) {
            return getReadableDate(date);
        },
    },
    components: { AddApartmentModal, Overlay, ApartmentDetailsModal, BasicSpinner }
})
